import Raven from 'raven-js';
const config = window.config;
if (!window.location.hostname.includes('local')) {
    Raven.config(config.sentryDSN).install();
}

